import classNames from 'classnames'
import { useState } from 'react'
import PopupMenu from '@/components/PopupMenu'
import EditIcon from '@/components/icons/EditIcon'


const defaultShadow = {
  blur:    6,
  color:   '#000000',
  opacity: 50,
  x:       0,
  y:       4,
}

const defaultGlow = {
  blur:    6,
  color:   '#FFFFFF',
  opacity: 80,
  x:       0,
  y:       2,
}

export default function ShadowPicker ({ shadow, colorEditable, onChange, onOpen, onClose}) {

  const [showSliders, setShowSliders] = useState(false)

  return (
    <PopupMenu
      className="toolbar-button"
      icon={
        <div
          className='text-lg default-text-color white bold'
          style={{
            filter: `drop-shadow(rgba(0, 0, 0, 0.4) 7px 5px 1px)`,
            transform: `translate(-2px, -2px)`,
          }}
        >
          S
        </div>
      }
      small
      onOpen={onOpen}
      onClose={onClose}
      tooltip="Shadow"
    >
      <div className='p-2 flex-col gap-2'>
        <div className='flex-col'>
          <div className='bold flex-row relative'>
            <button className={classNames('small button', {'bg-light-blue': !shadow})} onClick={() => {onChange(null); setShowSliders(false)}}>None</button>
            <button className={classNames('small button', {'bg-light-blue': shadow?.color === '#000000'})} onClick={() => onChange(defaultShadow)}>Shadow</button>
            <button className={classNames('small button', {'bg-light-blue': shadow?.color === '#FFFFFF'})} onClick={() => onChange(defaultGlow)}>Glow</button>
            <button className='small button is-inverted no-border px-2' onClick={() => {
              if (!shadow) onChange(defaultShadow)
              setShowSliders(v => !v)
            }}>
              <EditIcon/>
            </button>
          </div>
          <div className='relative' style={{maxHeight: showSliders ? 200 : 0, overflow: 'hidden', transition: 'max-height 300ms ease-in-out'}}>
            <ShadowFineTuning
              shadow={shadow}
              onChange={onChange}
              colorEditable={colorEditable}
            />
          </div>
        </div>

      </div>

    </PopupMenu>
  )
}


export function ShadowFineTuning({ shadow, onChange, colorEditable }) {

  return <>
    <div className='grid grid-cols-2 gap-2 px-2 mt-4'>
      <label>Horizonal</label>
      <input
        type="range"
        value={(shadow || defaultShadow).x}
        min="-20"
        max="20"
        onChange={e => onChange({...shadow, x: e.target.value})}
      />

      <label>Vertical</label>
      <input
        type="range"
        value={(shadow || defaultShadow).y}
        min="-20"
        max="20"
        onChange={e => onChange({...shadow, y: e.target.value})}
      />

      <label>Opacity</label>
      <input
        type="range"
        value={(shadow || defaultShadow).opacity}
        min="0"
        max="100"
        onChange={e => { onChange({...shadow, opacity: e.target.value}) }}
      />

      <label>Blur</label>
      <input
        type="range"
        value={(shadow || defaultShadow).blur}
        min="0"
        max="20"
        onChange={e => onChange({...shadow, blur: e.target.value})}
      />

      { colorEditable  &&
        <>
          <label>Color</label>
          <input
            type="color"
            value={(shadow || defaultShadow).color}
            onChange={e => { onChange({...shadow, color: e.target.value}) }}
          />
        </>
      }

    </div>
  </>

}